import { Component, Input, ViewChild, Renderer2, Inject, OnInit, ChangeDetectionStrategy, AfterViewInit, OnChanges, SimpleChanges, ViewEncapsulation, ChangeDetectorRef, Output, EventEmitter, ElementRef, Attribute } from '@angular/core';
import { CommonModule } from '@angular/common'; import { WidgetHelperService } from 'src/app/services/widget-helper.service';
import { ToastModule } from 'primeng/toast'; import { WidgetDetailsResponse } from 'src/app/models/widget';
import { WidgetsService } from 'src/app/services/widgets.service'; import { CartFacadeService } from 'src/app/services/cart-facade.service'; import { WidgetsWidgetService } from 'src/app/services/widgets-widget.service';
import { CarouselComponent } from '../carousel/carousel.component';
import { StoriesComponent } from '../stories/stories.component';
import { GridComponent } from '../grid/grid.component'; import { VideoModalComponent } from '../video-modal/video-modal.component';
import { MessageService } from 'primeng/api'; import { ProductService } from 'src/app/services/product.service';
import { PopupComponent } from '../popup/popup.component';
import { InlineComponent } from '../inline/inline.component';
import { StoreService } from 'src/app/services/store.service'; import { StoreWidgetService } from 'src/app/services/store-widget.service';
import { ButtonModule } from 'primeng/button'; import { VideoMuteService } from 'src/app/services/video-mute.service';
import { Item } from 'src/app/models/liveshop'; import { LogService } from 'src/app/services/log.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SkeletonModule } from 'primeng/skeleton'; import { ChatWebSocketService } from 'src/app/services/chat-web-socket.service'; import { ChatWebSocketWidgetService } from 'src/app/services/chat-web-socket-widget.service';
import { HttpClientModule } from '@angular/common/http';
import { VideoItem } from 'src/app/models/video-item.model';
import { PrimeNGConfig } from 'primeng/api'; import { StateManagementService } from 'src/app/services/state-management.service';
import { PMetaStoreService } from 'src/app/services/p-meta-store.service';
import { VideoModalService } from 'src/app/services/video-modal.service';
import { LiveShopService } from 'src/app/services/liveshop.service'; import { LiveShopWidgetService } from 'src/app/services/liveshop-widget.service'; import { CartShopifyService } from 'src/app/services/cart-shopify.service';
import { SidebarService } from 'src/app/services/sidebar.service'; import { ManangeLayoutService } from 'src/app/services/manange-layout.service';
import { environment } from 'src/environments/environment';
import { RouterModule } from '@angular/router';
import { ProductWidgetService } from 'src/app/services/product-widget.service';
import { DiscoverComponent } from '../discover/discover.component';
import { FakePagePreviewComponent } from '../fake-page-preview/fake-page-preview.component';
import { Subscription } from 'rxjs';


const widgetEncapsulation = environment.isWidgetBuild ? ViewEncapsulation.ShadowDom : ViewEncapsulation.Emulated;
const productServiceProvider = environment.isWidgetBuild
  ? { provide: ProductService, useClass: ProductWidgetService }
  : ProductService;
const chatWebSocketProvider = environment.isWidgetBuild
  ? { provide: ChatWebSocketService, useClass: ChatWebSocketWidgetService }
  : ChatWebSocketService;
const storeServiceProvider = environment.isWidgetBuild
  ? { provide: StoreService, useClass: StoreWidgetService }
  : StoreService;
const widgetsServiceProvider = environment.isWidgetBuild
  ? { provide: WidgetsService, useClass: WidgetsWidgetService }
  : WidgetsService;

@Component({
  selector: 'app-widget-template',
  standalone: true,
  templateUrl: './widget-template.component.html',
  styleUrls: ['./widget-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CarouselComponent,
    StoriesComponent,
    DiscoverComponent,
    GridComponent,
    SkeletonModule,
    PopupComponent,
    ButtonModule,
    InlineComponent,
    VideoModalComponent,
    ToastModule,
    RouterModule,
    FakePagePreviewComponent
  ],
  providers: [
    storeServiceProvider,
    widgetsServiceProvider,
    WidgetHelperService,
    MessageService, PMetaStoreService,
    VideoModalService,

    CartShopifyService,
    { provide: LiveShopService, useClass: LiveShopWidgetService },
    SidebarService,
    productServiceProvider,
    ManangeLayoutService,
    StateManagementService,
    chatWebSocketProvider,
    LogService,
    CartFacadeService,
    VideoMuteService,
  ],
  encapsulation: widgetEncapsulation,
  host: { 'class': 'ss-krabo-2025-widget' }
})
export class WidgetTemplateComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() containerDiv?: ElementRef<HTMLDivElement>;

  @Input('template-type') set templateTypeWeb(value: string | undefined) {
    this.templateType = value;
  }
  @Input() templateType?: string;
  @Input('instance-id') set setInstanceId(value: string | undefined) {
    this.instanceId = value ?? undefined;
  }
  instanceId?: string;

  @Input() discoverLayout: 'mosaic' | 'grid' = 'mosaic';
  @Input() discoverShowPostItemBadge = true; // novo switch

  @Input() popupPosition?: 'center' | 'top' | 'bottom' | 'left' | 'right' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright';
  @Input() highlight?: string;
  @Input() selectedShape?: string;
  @Input() bg_color?: string;
  @Input() font_color: string = '#000000';
  @Input() height?: number | undefined;
  @Input() aspectRatio?: any;
  @Input() showProducts?: boolean = false;
  @Input() showDescription?: boolean = false;

  @Input() showWidgetTitle?: boolean = false;
  @Input() widgetTitle?: string;
  @Input() widgetTitleTag: string = 'h2';
  @Input() titleAlignment: 'left' | 'center' | 'right' = 'left';
  @Input() titleSpacing: number = 24;
  @Input() paddingTop: number = 0;
  @Input() paddingRight: number = 0;
  @Input() paddingBottom: number = 0;
  @Input() paddingLeft: number = 0;
  @Input() paddingUnit: string = 'px';
  @Input() marginTop: number = 0;
  @Input() marginRight: number = 0;
  @Input() marginBottom: number = 0;
  @Input() marginLeft: number = 0;
  @Input() marginUnit: string = 'px';

  get paddingTopStyle(): string { return `${this.paddingTop}${this.paddingUnit}`; }
  get paddingRightStyle(): string { return `${this.paddingRight}${this.paddingUnit}`; }
  get paddingBottomStyle(): string { return `${this.paddingBottom}${this.paddingUnit}`; }
  get paddingLeftStyle(): string { return `${this.paddingLeft}${this.paddingUnit}`; }
  get marginTopStyle(): string { return `${this.marginTop}${this.marginUnit}`; }
  get marginRightStyle(): string { return `${this.marginRight}${this.marginUnit}`; }
  get marginBottomStyle(): string { return `${this.marginBottom}${this.marginUnit}`; }
  get marginLeftStyle(): string { return `${this.marginLeft}${this.marginUnit}`; }

  ///////////////////////
  // WidgetTemplateComponent

  private _storeId = 0;

  @Input()
  set store_id(value: any) {
    this.setStoreId(value);
  }
  get store_id(): number {
    return this._storeId;
  }

  // ✅ suporte ao Web Component (<slicksell-widget store-id="123">)
  @Input('store-id')
  set storeIdAttr(value: any) {
    this.setStoreId(value);
  }

  private setStoreId(value: any) {
    const n = Number(value);
    this._storeId = Number.isFinite(n) && n > 0 ? n : 0;
  }
  ///////////////////////
  @Input() widget_id?: number | undefined;
  @Input('widget-id') set setSelectedVideo(value: number | undefined) {
    this.widget_id = value;
    //this.loadVideos();
  }
  @Input("widget-uid") widget_uid?: string | undefined;

  @Input() limit: number | null = null;
  @Input() reloadRequest?: EventEmitter<void>;
  @Input() isCol4: boolean = false;
  @Input() isAdmin: boolean = false;
  @Input() selectedPopupPosition: 'center' | 'top' | 'bottom' | 'left' | 'right' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'bottomleft';
  @Input() showSmartphones: boolean = false;
  @Input() showDesktops: boolean = false;
  @Input() refreshTrigger: boolean = false;

  @Input() discoverDesign?: 'grid' | 'book';
  @Input() discoverIcon?: 'cart' | 'bag';
  @Input() discoverShowFilterBar?: boolean;

  totalAssets: number = 0;
  @Output() openSidebarEvent = new EventEmitter<void>();
  selectedResolution: any;
  pageToVideos: number = 0;
  resolutions: { label: string; value: { width: number; height: number } }[] = [];
  loading: boolean = false;
  videoUrls: VideoItem[] = [];
  posterUrls: string[] = [];
  private currentPage = 1;
  hasMoreVideos: boolean = true; // Flag para indicar se há mais vídeos disponíveis
  @Output() newVideos = new EventEmitter<VideoItem[]>();

  isMobileDevice(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isTouchCapable = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(userAgent) ||
      isTouchCapable
    );
  }

  constructor(
    private primengConfig: PrimeNGConfig,
    private renderer: Renderer2,
    private pMetaStore: PMetaStoreService,
    private storeService: StoreService,
    private widgetHelperService: WidgetHelperService,
    private messageService: MessageService,
    private widgetService: WidgetsService,
    private host: ElementRef<HTMLElement>
  ) {
  }

  ngAfterViewInit() {
    if (!this.isAdmin) {
      this.pMetaStore.sendWidgetEvent(this.widget_uid, this.templateType);
    }
  }

  ngOnInit(): void {
    console.log('UPT 1.0')
    this.primengConfig.ripple = true;
    this.applyWebComponentClasses();
  }
  // Método que será chamado pelo navegador quando o Web Component for adicionado à página
  connectedCallback() {
    this.applyWebComponentClasses();
  }
  onOpenSidebar(): void {
    this.openSidebarEvent.emit();
  }
  // Teste de atualização do store 2.0
  async updateStore(store_id: number | undefined) {
    console.log('updateStore')
    console.log(store_id)
    try {
      const observable = await this.storeService.detailStoreInfosByID(store_id);

      observable.subscribe({
        next: (response: any) => {

          ///////////////////////////
          const storeInfo = this.buildStoreInfo(response);

          localStorage.setItem('ss_SelectedStoreId', String(response.id));
          localStorage.setItem('store', JSON.stringify(storeInfo));

          // espelha plataforma pra compatibilidade com código antigo
          localStorage.setItem('ss_cart_platform', storeInfo.ssCartPlatform || storeInfo.ss_cart_platform || 'other');
          console.log('verificando response')
          console.log(storeInfo)
          ///////////////////////////
        },
        error: (err) => {
          console.error('Erro ao detalhar store:', err);
        }
      });
    } catch (err) {
      console.error('Erro ao iniciar requisição detailStoreInfosByID:', err);
    }
  }

  private buildStoreInfo(response: any) {
    const rawPlatform = String(response?.ss_cart_platform || '').toLowerCase();

    let normalizedPlatform: 'shopify' | 'nuvemshop' | 'other' = 'other';
    if (rawPlatform.includes('shopify')) normalizedPlatform = 'shopify';
    else if (rawPlatform.includes('nuvemshop')) normalizedPlatform = 'nuvemshop';

    const storeInfo: any = {
      SelectedStoreId: response?.id,
      store_logo: response?.store_logo,

      // mantém compatibilidade
      ss_cart_platform: response?.ss_cart_platform,
      ss_cart_page: response?.ss_cart_page,

      // seu campo normalizado
      ssCartPlatform: normalizedPlatform,
    };

    // se vier do backend (detalhe da nuvemshop) já salva
    if (response?.ss_nuvemshop_domain) {
      storeInfo.ss_nuvemshop_domain = response.ss_nuvemshop_domain;
    }

    // se esse endpoint tiver domínio/subdomínio, salva também (não atrapalha)
    if (response?.store_link_subdomain) {
      storeInfo.domain_store = response.store_link_subdomain;
    }

    return storeInfo;
  }


  newMethod() {
    if (this.store_id) {
      this.aspectRatio = 'det / rtuu6';
    }
  }
  ngOnChanges(changes: SimpleChanges): void { // 
    const widgetChanged = !!changes['widget_id'];
    const storeChanged = !!changes['store_id'] || !!changes['storeIdAttr']; // storeIdAttr é o alias

    if (widgetChanged || storeChanged) {
      // só faz request quando tiver widget e store válidos
      if (this.widget_id && this.store_id) {
        this.currentPage = 1;
        this.hasMoreVideos = true;
        this.videoUrls = [];
        this.arraySlicksFull = [];

        this.loadVideos();
      }
    }

    if (changes['widget_id'] && this.widget_id) {
      this.currentPage = 1; // Resetar para a primeira página sempre que o widget_id mudar
      this.hasMoreVideos = true; // Sempre reiniciar com "mais vídeos disponíveis" ao mudar de widget
    }
    if (changes['showProducts']) {
    }
    if (changes['showDescription']) {
    }
    if (changes['widget_uid']) {
    }
    if (changes['store_id']) {
      if (changes['store_id'].currentValue) {
      }

    }
    if (changes['isAdmin']) {
      //this.loadVideos();
    }
    if (changes['refreshTrigger']) {
      this.currentPage = 1;
      this.hasMoreVideos = true;

      if (this.widget_id && this.store_id) {
        this.loadVideos(true);
      }
    }
    if (changes['widget_id']) {
      if (!this.isAdmin) {
        //this.widgetDetail();
      }
      //this.loadVideos();
    }
    if (changes['font_color']) {
    }
    if (changes['showSmartphones']) {
      this.showSmartphones = changes['showSmartphones'].currentValue;
    }
    if (changes['showDesktops']) {
      this.showDesktops = changes['showDesktops'].currentValue;
    }
    this.disableClicks = (
      (!this.showDesktops && !this.isMobileDevice()) ||
      (!this.showSmartphones && (this.isMobileDevice() || this.isCol4))
    );

    if (changes['templateType']) {
    }
    if (changes['store_id']) {
    }

    const colChange = changes['isCol4'];
    if (colChange) {
      const prev = !!colChange.previousValue;
      const curr = !!colChange.currentValue;

      // ✅ quando VOLTA do col4 (true -> false), reseta tudo e recarrega primeira página
      if (prev === true && curr === false) {
        this.resetDiscoverPagingAndReload();
      }
    }

    // Precisa rodar em TODO ciclo de ngOnChanges, não só quando isCol4 muda — senão o
    // switch de Devices (showSmartphones/showDesktops) só teria efeito visual depois que
    // algo mais mudasse isCol4 junto (ex: trocar a aba Desktop/Mobile da prévia).
    this.applyWebComponentClasses();
  }

  private resetDiscoverPagingAndReload(): void {
    this.loadSeq++;
    this.loadSub?.unsubscribe();
  
    this.loading = true;
    this.currentPage = 1;
    this.hasMoreVideos = true;
    this.videoUrls = [];
    this.arraySlicksFull = [];
  
    void this.loadVideos();
  }
  disableClicks: boolean = false;
  widgetDetail() {
    if (this.widget_uid) {
      this.widgetService.detailWidget(this.widget_uid).pipe().subscribe({
        next: (res: WidgetDetailsResponse) => {
          if (res.style) {
            const styleKeys = Object.keys(res.style);
            if (styleKeys.length > 0) {
              this.templateType = styleKeys[0];
            }
          }
          if (res.style && res.style.popup) {
            const styleKeys = Object.keys(res.style);
            if (styleKeys.length > 0) {
              this.templateType = styleKeys[0];
            }
            this.highlight = res.style.popup.highlight || '';
            this.selectedShape = res.style.popup.shape || 'circle';
            this.bg_color = res.style.popup.background_color || '#ffffff';
            this.font_color = res.style.popup.font_color || '#000000';
          }
          if (res.style && res.style.carousel) {
            this.showProducts = res.style.carousel.showProducts;
            this.showDescription = res.style.carousel.showDescription;
            this.highlight = res.style.popup.highlight || '';
            this.bg_color = res.style.popup.background_color || '#ffffff';
            this.font_color = res.style.popup.font_color || '#000000';
            const position = res.style.carousel.position;
            this.selectedPopupPosition = position && ['center', 'top', 'bottom', 'left', 'right', 'topleft', 'topright', 'bottomleft', 'bottomright'].includes(position)
              ? this.widgetHelperService.mapPositionValue(position)
              : 'bottomleft';
          }
          if (res.style && res.style.stories) {
            this.showProducts = res.style.inline.showProducts;
            this.highlight = res.style.popup.highlight || '';
            this.bg_color = res.style.popup.background_color || '#ffffff';
            this.font_color = res.style.popup.font_color || '#000000';
            const position = res.style.stories.position;
            this.selectedPopupPosition = position && ['center', 'top', 'bottom', 'left', 'right', 'topleft', 'topright', 'bottomleft', 'bottomright'].includes(position)
              ? this.widgetHelperService.mapPositionValue(position)
              : 'bottomleft';
          }
          this.resolutions = this.widgetHelperService.getResolutions();
          if (res.style && res.style.iframe && res.style.iframe.selectedResolution) {
            const savedResolution = res.style.iframe.selectedResolution;
            const resolution = this.resolutions.find(
              r => r.value.width === savedResolution.width && r.value.height === savedResolution.height
            );

            if (resolution) {
              this.height = resolution.value.height;
            }


          }
          if (res.style && res.style.inline) {
            this.showDescription = res.style.inline.showDescription;
            this.showProducts = res.style.inline.showProducts;

            const savedResolution = res.style.inline.selectedResolution;
            if (savedResolution) {
              const resolution = this.resolutions.find(
                r => r.value.width === savedResolution.width && r.value.height === savedResolution.height
              );

              if (resolution) {
                this.selectedResolution = resolution.value;
                this.height = resolution.value.height;
              }
            }
            this.showSmartphones = res.widget_rule.device_display.mobile_display;
            this.showDesktops = res.widget_rule.device_display.desktop_display;

          }
        },
        error: (err) => {
          this.loading = false;
        }
      });
    }
  }
  capitalizeFirstLetter(text: string | undefined): string {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
  arraySlicksFull: Item[] = [];
  @Output() loadingComplete = new EventEmitter<void>();
  private loadSeq = 0;
  private loadSub?: Subscription;

  // no topo do componente (WidgetTemplateComponent), adicione:
private loadVideosSub?: { unsubscribe: () => void };
private loadVideosReqId = 0;

async loadVideos(isRefresh = false): Promise<void> {
  await this.updateStore(this.store_id);

  if (!this.hasMoreVideos) {
    this.loadingComplete.emit();
  }

  if (!this.widget_id || !this.hasMoreVideos) return;

  // ✅ cancela request anterior (evita race condition e page pulando)
  try { this.loadVideosSub?.unsubscribe(); } catch {}

  this.loading = true;

  // ✅ snapshot do page pedido + request id (pra ignorar resposta atrasada)
  const requestId = ++this.loadVideosReqId;
  const requestedPage = this.currentPage;

  let request$: any;

  if (this.isAdmin) {
    request$ = await this.storeService.listarAssetsWidget2(
      this.widget_id,
      requestedPage,
      10,
      this.discoverFilters
    );
  } else {
    request$ = this.storeService.listarAssetsWidgetPublic(
      this.widget_id,
      requestedPage,
      10,
      this.store_id,
      this.discoverFilters
    );
  }

  this.loadVideosSub = request$.subscribe(
    (response: any) => {
      console.log('trouxe itens')
      console.log(response)
      // ✅ se não for o request mais recente, ignora (não mexe em page/lista/loading)
      if (requestId !== this.loadVideosReqId) return;

      this.loading = false;

      // Atualize arraySlicksFull com todos os itens recebidos
      const newItems = (response?.assets ?? []).flatMap((asset: any) => asset.items);

      this.arraySlicksFull = isRefresh ? [...newItems] : [...this.arraySlicksFull, ...newItems];

      const totalNewItems = newItems.length;
      this.pageToVideos = Math.ceil(totalNewItems / 3);

      const newVideoItems = (response?.assets ?? []).flatMap((asset: any) =>
        (asset.items ?? []).map((item: any) => {
          const products = item?.content?.cta?.components?.products?.items ?? [];
          return {
            src: item?.media?.src,
            thumbnail: item?.media?.thumbnail ?? 'assets/imgTmp.webp',
            title: item?.content?.title,
            uid: item?.content?.uid,
            id: item?.content?.id,
            description: item?.content?.description,
            products: products.length > 0 ? products : []
          };
        })
      );

      this.totalAssets = response?.totalAssets;

      // ✅ certo: vem do backend
      const hasMore = !!response?.hasMore;
      this.hasMoreVideos = hasMore;

      if (newVideoItems.length === 0) {
        this.hasMoreVideos = false;
        if (isRefresh) {
          this.videoUrls = [];
        }
        this.loadingComplete.emit();
        return;
      }

      if (isRefresh) {
        this.videoUrls = newVideoItems;
      } else {
        const mergedVideos = [...this.videoUrls, ...newVideoItems];
        this.videoUrls = Array.from(new Map(mergedVideos.map(v => [v.uid, v])).values());
      }

      // ✅ ANTI-PULO:
      // só incrementa se o page atual ainda é o mesmo que foi pedido
      // (se algum reset colocou currentPage=1 de novo durante request, não deixa pular)
      if (this.hasMoreVideos && this.currentPage === requestedPage) {
        this.currentPage++;
      }

      this.newVideos.emit(this.videoUrls);
      this.loadingComplete.emit();

      /////////////////////////
      // Agora, configuramos as variáveis usando as informações do objeto widget (que está dentro de `response`)
      if (response?.widget) {
        const widget = response.widget;
        const widgetRule = response.widget_rule;

        this.widget_id = widget.id;
        this.widget_uid = widget.uid;

        // Aqui você pode configurar o display do widget de acordo com os valores recebidos:
        this.showSmartphones = widgetRule.device_display.mobile_display == 1 ? true : false;
        this.showDesktops = widgetRule.device_display.desktop_display == 1 ? true : false;

        // disableClicks
        this.disableClicks = (
          (!this.showDesktops && !this.isMobileDevice()) ||
          (!this.showSmartphones && (this.isMobileDevice() || this.isCol4))
        );

        // Se houver estilo definido para o widget, lidamos com ele aqui
        if (widget.style && !this.isAdmin) {
          // Tratando os estilos do popup
          if (widget.style.popup) {
            const position = widget.style.popup.position;
            this.selectedPopupPosition =
              position && ['center', 'top', 'bottom', 'left', 'right', 'topleft', 'topright', 'bottomleft', 'bottomright'].includes(position)
                ? this.widgetHelperService.mapPositionValue(position)
                : 'bottomleft';

            this.highlight = widget.style.popup.highlight || '';
            this.selectedShape = widget.style.popup.shape || 'circle';
            this.bg_color = widget.style.popup.background_color || '#ffffff';
            this.font_color = widget.style.popup.font_color || '#000000';

            if (widget.style.popup.height) {
              this.height = widget.style.popup.height;
            }
            this.popupPosition = position;
          }

          // Estilo para o tipo "inline"
          if (widget.style.inline) {
            this.showDescription = widget.style.inline.showDescription;
            this.showProducts = widget.style.inline.showProducts;

            const savedResolution = widget.style.inline.selectedResolution;
            if (savedResolution) {
              const resolution = this.resolutions.find(
                r => r.value.width === savedResolution.width && r.value.height === savedResolution.height
              );

              if (resolution) {
                this.selectedResolution = resolution.value;
                this.height = resolution.value.height;
              }
            }
          }

          // Estilo para o tipo "carousel"
          if (widget.style.carousel) {
            this.showProducts = widget.style.carousel.showProducts;
            this.showDescription = widget.style.carousel.showDescription;
            this.bg_color = widget.style.carousel.background_color || '#ffffff';
            this.font_color = widget.style.carousel.font_color || '#000000';

            const position = widget.style.carousel.position;
            this.selectedPopupPosition =
              position && ['center', 'top', 'bottom', 'left', 'right', 'topleft', 'topright', 'bottomleft', 'bottomright'].includes(position)
                ? this.widgetHelperService.mapPositionValue(position)
                : 'bottomleft';
          }

          // Estilo para o tipo "stories"
          if (widget.style.stories) {
            this.showProducts = widget.style.stories.showProducts;
            this.highlight = widget.style.stories.highlight || '';
            this.bg_color = widget.style.stories.background_color || '#ffffff';
            this.font_color = widget.style.stories.font_color || '#000000';

            const position = widget.style.stories.position;
            this.selectedPopupPosition =
              position && ['center', 'top', 'bottom', 'left', 'right', 'topleft', 'topright', 'bottomleft', 'bottomright'].includes(position)
                ? this.widgetHelperService.mapPositionValue(position)
                : 'bottomleft';
          }

          // Set the resolutions and default resolution
          this.resolutions = this.widgetHelperService.getResolutions();
          this.selectedResolution = this.resolutions[2].value;

          const savedResolution =
            widget.style.iframe?.selectedResolution || widget.style.inline?.selectedResolution;

          if (savedResolution) {
            const resolution = this.resolutions.find(
              r => r.value.width === savedResolution.width && r.value.height === savedResolution.height
            );

            if (resolution) {
              this.selectedResolution = resolution.value;
              this.height = resolution.value.height;
            }
          }

          // Definir o aspect ratio com base na resolução selecionada
          const width = this.selectedResolution.width;
          const height = this.selectedResolution.height;
          this.aspectRatio = `${width} / ${height}`;

          // Handle iframe selected resolution
          if (widget.style.iframe?.selectedResolution) {
            let w = 100;
            if (this.aspectRatio && this.height) {
              const [ratioWidth, ratioHeight] = this.aspectRatio.split('/').map(Number);
              w = this.height * (ratioWidth / ratioHeight);
            }
          }

          this.applyWebComponentClasses();
        }

        ///////////////////////// showDesktops
        this.showDesktops = response.widget_rule.device_display.desktop_display == 1 ? true : false;
        this.showSmartphones = response.widget_rule.device_display.mobile_display == 1 ? true : false;
      }
      /////////////////////////
    },
    (error: any) => {
      // ✅ só derruba loading se ainda for o request atual
      if (requestId === this.loadVideosReqId) {
        this.loading = false;
      }
      this.handleError(error);
    }
  );
}

  loadMoreVideosForGrid(): void {
    if (this.templateType === 'grid' && !this.loading) {
      this.loadVideos();
    }
  }

  loadMoreVideosForCarousel(): void {
    if ((this.templateType === 'carousel' || this.templateType === 'stories') && !this.loading) {
      this.loadVideos();
    }
  }

  handleError(error: any): void {
    let message = '';
    if ([400, 403, 401, 404, 429].includes(error.status)) {
      message = error.error.message;
    } else if (error.status === 500) {
      message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
    }
    if (message) {
      this.showErrorDialog(message);
    }
    console.error('erro:', error);
  }

  showErrorDialog(message: string) {
    this.messageService.add({ severity: 'error', summary: 'Erro', detail: message, icon: 'pi pi-times' });
  }

  @ViewChild('classContainer', { static: true }) classContainer!: ElementRef<HTMLDivElement>;

  // Efeito "olhando desabilitado" (hachurado + opacity, .ss-l-admin-mode) na prévia do admin
  // quando o device atual está desligado em Devices. Exposto como propriedade (em vez de
  // aplicado via Renderer2 no #classContainer) pra poder ser aplicado só no conteúdo real do
  // template (dentro do app-fake-page-preview / app-popup), não na "página fake" inteira.
  adminDeviceDisabled: boolean = false;

  applyWebComponentClasses() {
    if (!this.classContainer?.nativeElement) return;
    const el = this.classContainer.nativeElement;

    // Remove todas as classes antes de aplicar as novas
    el.classList.remove(
      'ss-l-show-desktop-device',
      'ss-l-not-show-desktop-device',
      'ss-l-show-mobile-device',
      'ss-l-not-show-mobile-device'
    );

    this.adminDeviceDisabled = this.isAdmin && this.templateType !== 'iframe' && (
      (!this.showDesktops && !this.isMobileDevice() && !this.isCol4) ||
      ((this.isMobileDevice() && !this.showSmartphones) ||
        (!this.isMobileDevice() && !this.showSmartphones && this.isCol4))
    );

    if (this.templateType === 'iframe' && this.isAdmin
      ? this.showDesktops && !this.isMobileDevice()
      : (!this.isAdmin && this.showDesktops && !this.isMobileDevice())
    ) {
      this.renderer.addClass(el, 'ss-l-show-desktop-device');
    }

    if (this.templateType !== 'iframe' && !this.isAdmin && !this.showDesktops && !this.isMobileDevice()) {
      this.renderer.addClass(el, 'ss-l-not-show-desktop-device');
    }

    if (this.templateType === 'iframe'
      ? this.showSmartphones && (this.isMobileDevice() || this.isCol4)
      : (!this.isAdmin && this.showSmartphones && (this.isMobileDevice() || this.isCol4))
    ) {
      this.renderer.addClass(el, 'ss-l-show-mobile-device');
    }


    if (this.templateType !== 'iframe' && !this.isAdmin && !this.showSmartphones && (this.isMobileDevice() || this.isCol4)) {
      this.renderer.addClass(el, 'ss-l-not-show-mobile-device');
    }
  }

  discoverFilters = { categoryIds: [] as number[], influencerHandles: [] as string[] };

  onDiscoverFiltersChange(ev: { categoryIds: number[]; influencerHandles: string[] }) {
    this.discoverFilters = ev;

    // quando mudar filtro: reseta paginação e lista
    this.currentPage = 1;
    this.hasMoreVideos = true;
    this.videoUrls = [];
    this.arraySlicksFull = [];

    this.loadVideos(); // chama backend já com filtros
  }
}
